import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import SubmissionDetail from './SubmissionDetail';

const IntakeQueueApp = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/:id" element={<SubmissionDetail />} />
      <Route path="*" element={<Navigate to="/intake-queue" replace />} />
    </Routes>
  );
};

export default IntakeQueueApp;
